import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import LandingSection from "../components/LandingSection";
import ActionButton from "../utils/ActionButton";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
// List of 21 unique images with titles and descriptions
// const images = [

//     {
//       url: "/img/bee.jpg",
//       title: " Beehive Sport & Social Club ",
//       description: "   Sports : Various (Kickball, Softball, etc.) \n Location : Salt Lake City ",
//     },
//     {
//       url: "/img/og.avif",
//       title: " Ogden Mustangs ",
//       description: "   Sports : Ice Hockey (Junior) \n Location : Ogden ",
//     },
//     {
//       url: "/img/park.avif",
//       title: " Park City Miners ",
//       description: "   Sports : Various (often youth sports) \n Location : Park City ",
//     },
//     {
//       url: "/img/football.webp",
//       title: " Real Salt Lake (RSL) ",
//       description: "   Sports : Soccer \n Location : Sandy (near Salt Lake City) ",
//     },
//     {
//       url: "/img/base.jpeg",
//       title: " Salt Lake Bees ",
//       description: "   Sports : Baseball \n Location : Salt Lake City ",
//     },
//     {
//       url: "/img/slc.avif",
//       title: " Salt Lake City Stars ",
//       description: "   Sports : Basketball (G League) \n Location : Salt Lake City ",
//     },
//     {
//       url: "/img/paani.jpg",
//       title: " Sports Academy & Racquet Club ",
//       description: "   Sports : Tennis, Fitness, etc. \n Location : Varies (likely Salt Lake City area) ",
//     },
//     {
//       url: "/img/uus.jpg",
//       title: " University of Utah Club Sports ",
//       description: "   Sports : Various \n Location : Salt Lake City (University of Utah) ",
//     },

//     {
//       url: "/img/bhalu.jpg",
//       title: " Utah Grizzlies ",
//       description: "   Sports : Ice Hockey \n Location :  West Valley City (near Salt Lake City)",
//     },
//     {
//       url: "/img/icehoc.avif",
//       title: " Utah Hockey Club ",
//       description: "   Sports : Ice Hockey \n Location :  Salt Lake City ",
//     },
//     {
//       url: "/img/jazz.jpg",
//       title: "Utah Jazz",
//       description: "   Sports : Basketball \n Location : Salt Lake City  ",
//     },

//     {
//       url: "/img/wofootball.jpg",
//       title: " Utah Royals FC ",
//       description: "   Sports :  Female Soccer \n Location : Sandy (near Salt Lake City)  ",
//     },
//     {
//       url: "/img/crop.webp",
//       title: " Utah State University Club Sports ",
//       description: "   Sports : Various \n Location : Logan (Utah State University) ",
//     },
//     {
//       url: "/img/sp.webp",
//       title: " Utah Tech University Club Sports ",
//       description: "   Sports : Various \n Location : St. George (Utah Tech University) ",
//     },
//     {
//       url: "/img/rugby.jpg",
//       title: " Utah Warriors ",
//       description: "   Sports : Rugby \n Location : Herriman (near Salt Lake City) ",
//     }

// ];

const images = [
  {
    url: "/img/bee.jpg",
    title: " Beehive Sport & Social Club ",
    description:
      "   Sports : Various (Kickball, Softball, etc.) \n Location : Salt Lake City ",
    link: "https://www.beehivesports.com/",
  },
  {
    url: "/img/og.avif",
    title: " Ogden Mustangs ",
    description: "   Sports : Ice Hockey (Junior) \n Location : Ogden ",
    link: "https://www.ogdenmustangs.com/",
  },
  {
    url: "/img/park.avif",
    title: " Park City Miners ",
    description:
      "   Sports : Various (often youth sports) \n Location : Park City ",
    link: "https://www.pciceminers.org/",
  },
  {
    url: "/img/football.webp",
    title: " Real Salt Lake (RSL) ",
    description:
      "   Sports : Soccer \n Location : Sandy (near Salt Lake City) ",
    link: "https://www.rsl.com/",
  },
  {
    url: "/img/base.jpeg",
    title: " Salt Lake Bees ",
    description: "   Sports : Baseball \n Location : Salt Lake City ",
    link: "https://www.milb.com/salt-lake",
  },
  {
    url: "/img/slc.avif",
    title: " Salt Lake City Stars ",
    description:
      "   Sports : Basketball (G League) \n Location : Salt Lake City ",
    link: "https://saltlakecity.gleague.nba.com/",
  },
  {
    url: "/img/paani.jpg",
    title: " Sports Academy & Racquet Club ",
    description:
      "   Sports : Tennis, Fitness, etc. \n Location : Varies (likely Salt Lake City area) ",
    link: "https://www.sportsacademy.com/",
  },
  {
    url: "/img/uus.jpg",
    title: " University of Utah Club Sports ",
    description:
      "   Sports : Various \n Location : Salt Lake City (University of Utah) ",
    link: "https://campusrec.utah.edu/sport-clubs/index.php",
  },
  {
    url: "/img/bhalu.jpg",
    title: " Utah Grizzlies ",
    description:
      "   Sports : Ice Hockey \n Location :  West Valley City (near Salt Lake City)",
    link: "https://utahgrizzlies.com/",
  },
  {
    url: "/img/icehoc.avif",
    title: " Utah Hockey Club ",
    description: "   Sports : Ice Hockey \n Location :  Salt Lake City ",
    link: "https://www.nhl.com/utah/",
  },
  {
    url: "/img/jazz.jpg",
    title: "Utah Jazz",
    description: "   Sports : Basketball \n Location : Salt Lake City  ",
    link: "https://www.nba.com/jazz/",
  },
  {
    url: "/img/wofootball.jpg",
    title: " Utah Royals FC ",
    description:
      "   Sports :  Female Soccer \n Location : Sandy (near Salt Lake City)  ",
    link: "https://www.rsl.com/utahroyals/",
  },
  {
    url: "/img/crop.webp",
    title: " Utah State University Club Sports ",
    description:
      "   Sports : Various \n Location : Logan (Utah State University) ",
    link: "https://www.usu.edu/campusrec/competitive-sports/club-sports/",
  },
  {
    url: "/img/sp.webp",
    title: " Utah Tech University Club Sports ",
    description:
      "   Sports : Various \n Location : St. George (Utah Tech University) ",
    link: "https://recreation.utahtech.edu/club-sports/",
  },
  {
    url: "/img/rugby.jpg",
    title: " Utah Warriors ",
    description:
      "   Sports : Rugby \n Location : Herriman (near Salt Lake City) ",
    link: "https://www.warriorsrugby.com/",
  },
];

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  height: 300,
  flex: "1 1 calc(30% - 34px)", // Default width for larger screens
  margin: "44px", // Default margin
  padding: "8px",
  [theme.breakpoints.down("md")]: {
    flex: "1 1 calc(45% - 34px)", // Slightly wider cards for medium screens
  },
  [theme.breakpoints.down("sm")]: {
    flex: "1 1 calc(90% - 20px)", // Increase width for mobile screens
    margin: "20px auto", // Center cards and reduce margin
  },
  "&:hover .description": {
    opacity: 1,
    transform: "translateY(0)",
  },
  "&:hover, &.Mui-focusVisible": {
    zIndex: 1,
    boxShadow: "0 0 8px rgba(255, 255, 255, 0.8)",
    transform: "scale(0.95)",
    "& .MuiImageBackdrop-root": {
      opacity: 0.15,
    },
    "& .MuiTypography-root": {
      border: "4px solid currentColor",
      textShadow: "1px 1px 2px rgba(0, 0, 0, 0.8)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
}));

const Image = styled("span")(({ theme }) => ({
  position: "absolute",
  left: "16px",
  right: "16px",
  top: "16px",
  bottom: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
}));

const ImageSrc = styled("span")({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
});

const ImageBackdrop = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.4,
  transition: theme.transitions.create("opacity"),
}));

const ImageMarked = styled("span")(({ theme }) => ({
  height: 3,
  width: 18,
  backgroundColor: theme.palette.common.white,
  position: "absolute",
  bottom: -2,
  left: "calc(50% - 9px)",
  transition: theme.transitions.create("opacity"),
}));

export default function Sports() {
  return (
    <div>
      <LandingSection
        data={{
          imageName: "sports.webp",
          title: "Utah Sports Club",
          visible: "",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah’s Sports Club ({images.length})</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah sports clubs foster community engagement and athletic
              excellence through diverse programs in soccer, basketball,
              football, and more across the state.
            </p>
            <Link to={"/about"}>
              {/* <ActionButton data="Know More About Us" /> */}
            </Link>
          </div>
        </div>
      </div>

      <div className="  p-[2rem]">
        <h2 className="text-5xl font-bold text-center mb-6">
          Sports Club in Utah
        </h2>
        <div className="font-bold text-3xl text-center">
          (15 Sports Club 2024)
        </div>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            padding: "26px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center", // or "space-between", "space-around"
              gap: "36px",
            }}
          >
            {images.map((image) => (
              <a
                href={image.link}
                target="_blank"
                rel="noopener noreferrer"
                key={image.title}
                // style={{
                //   textDecoration: "none",
                //   width: "500px", // Set consistent width for cards
                //   height: "200px"
                // }}
                className="no-underline sm:w-[500px] w-[350px] sm:h-[200px] h-[300px]"
              >
                <ImageButton
                  focusRipple
                  style={{
                    width: "100%", // Let it take full anchor width
                    height: "200px", // Adjust as needed
                    background: `url(${image.url}) center/cover no-repeat`,
                  }}
                >
                  <ImageBackdrop className="MuiImageBackdrop-root" />
                  <Image>
                    <Typography
                      component="span"
                      variant="h5"
                      color="inherit"
                      sx={{
                        position: "relative",
                        padding: "8px 16px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {image.title}
                      <Typography
                        className="description !border-none"
                        sx={{
                          fontSize: "18px",
                          color: "#FFAA1D",
                          marginTop: "8px",
                          whiteSpace: "pre-line",
                          opacity: 0,
                          transition: "opacity 0.3s, transform 0.3s",
                          transform: "translateY(10px)",
                          border: "none",
                          fontWeight: "bold",
                          backgroundColor: "transparent !important",
                        }}
                      >
                        {image.description}
                      </Typography>
                      <ImageMarked className="MuiImageMarked-root" />
                    </Typography>
                  </Image>
                </ImageButton>
              </a>
            ))}
          </div>
        </Box>
        <div className="mt-16 border-t border-gray-300 pt-6 text-center text-sm text-gray-700 max-w-3xl mx-auto px-4">
          <p>
            <strong>Disclaimer:</strong> UtahData is an independent platform
            that compiles public information about sports clubs in Utah. We do
            not claim any rights to logos, names, or content of the listed
            organizations. All data is for informational purposes only— please
            refer to official websites for the most accurate and up-to-date
            information.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
